import { Button } from 'antd';
import Container from 'common/components/container.component';
import EmptyResults from 'common/components/empty-results.component';
import SessionOverlay from 'common/components/session-overlay.component';
import { AuthTranscription } from 'config/constants/transcription.constant';
import AuthIntentUtils from 'config/utils/auth-intent.util';
import NavigationUtils from 'config/utils/navigation.util';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RouteProps, useLocation } from 'react-router-dom';
import { RootState } from 'store/index';
import styles from './private.route.module.scss';

const PrivateRoute: React.FC<RouteProps> = ({ children }): React.ReactNode => {
  const { isAuthenticated, sessionExpired } = useSelector((state: RootState) => state.auth);
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated) return;
    AuthIntentUtils.requireAuth({
      redirectTo: NavigationUtils.getLocationRedirectPath(window.location.pathname, window.location.search),
    });
  }, [isAuthenticated, sessionExpired]);

  const handleOpenLogin = () => {
    AuthIntentUtils.requireAuth({
      redirectTo: NavigationUtils.getLocationRedirectPath(location.pathname, location.search),
    });
  };

  if (isAuthenticated) return children;

  if (sessionExpired) {
    return (
      <div className={styles['route-shell']}>
        {children}
        <SessionOverlay />
      </div>
    );
  }

  return (
    <Container>
      <EmptyResults
        title={AuthTranscription.AUTH_REQUIRED_TO_CONTINUE}
        action={
          <Button type='primary' onClick={handleOpenLogin}>
            {AuthTranscription.FORM_LOGIN_TEXT}
          </Button>
        }
      />
    </Container>
  );
};

export default PrivateRoute;
